<template>
    <div>
        <div class="agreement" v-if="!isScret">
            <p style="text-align:center;font-size:0.18rem;font-weight: 600;">《紫金保险线上平台用户服务协议》</p>
            <p>1、特别提醒</p>
            <p>1.1《紫金保险线上平台用户服务协议》（以下简称“本协议”）作为紫金财产保险股份有限公司（以下简称“紫金保险”）提供线上服务的依据，确定用户在何种条件、以何种方式使用紫金保险线上平台（包括网站、移动设备客户端、微信公众号、微信小程序等）及其服务。在您注册成为“紫金保险线上平台”的用户或使用、接受“紫金保险线上平台”的服务之前，您确认已充分阅读、理解并接受本协议的全部内容，特别是免除或限制责任的相应条款，限制、免责条款以加粗形式提示您注意。除非您已阅读并接受本协议所有条款，否则你无权使用“紫金保险线上平台”的服务。当您登录、查看、发布信息时即视为您已阅读并同意接爱本协议的约束；</p>
            <p class="stronger">1.2“紫金保险线上平台”有权随时对本协议内容进行单方面的变更，并以“紫金保险线上平台”公告的方式予以公布，无需另行单独通知；</p>
            <p class="stronger">1.3若您在本协议内容公告变更后继续使用、接受“紫金保险线上平台”的服务，表示您已充分阅读、理解并接受修改后的协议内容，并同意遵循修改后协议的所有约定；若您不同意修改后的协议内容应当立即停止使用“紫金保险线上平台”的服务。</p>
            <p>2、定义</p>
            <p>2.1“紫金保险线上平台”是指紫金财产保险股份有限公司运营的保险线上平台（包括网站、移动设备客户端、微信公众号、微信小程序等）及其服务；</p>
            <p>2.2“紫金保险线上平台用户”指同意参加“紫金保险线上平台”平台合作，遵守本协议约定，完成“紫金保险线上平台”用户在线注册并具备履行该平台合作所需的相应能力的个人。</p>
            <p>3、注册条款</p>
            <p class="stronger">3.1“紫金保险线上平台”的用户，需要具有法律规定的完全民事权利能力和民事行为能力，是能够独立承担民事责任的自然人。不具备前述主体资格应当立即停止注册或停止使用“紫金保险线上平台”的服务，由此导致的一切后果由个人及其监护人承担。</p>
            <p>3.2注册“紫金保险线上平台”的用户时，需要提供注册人的姓名、性别、年龄、出生日期、身份证号码等相关信息及相应的证件资料。</p>
            <p>3.3在注册成为“紫金保险线上平台”的用户或使用、接受“紫金保险线上平台”的服务时，需同意并履行如下义务：</p>
            <p>3.3.1在注册时，向“紫金保险线上平台”提供真实、准确、即时、完整的注册信息及相应的证件资料并及时更新上述信息及资料以保持其真实、准确、即时、完整；</p>
            <p>3.3.2在确知或者有合理理由怀疑您提供的信息不真实、不准确、不即时、不完整时，“紫金保险线上平台”有权暂停或终止服务；</p>
            <p class="stronger">3.3.3因用户注册时提供的电子邮件地址、手机或座机号码无法及时与用户取得联系，导致用户在使用“紫金保险线上平台”服务过程中产生任何损失或增加费用的，由用户自行承担；</p>
            <p>3.3.4“紫金保险线上平台”有权以各种方式（包括但不限于电子邮件、手机短信、微信公众号）发送与“紫金保险线上平台”所提供服务相关的各类商业信息，如拒绝继续接收上述商业信息，必须通过书面方式通知“紫金保险线上平台”；</p>
            <p>4、用户行为管理</p>
            <p>4.1用户在“紫金保险线上平台”平台操作权限仅限定于使用“紫金保险线上平台”进行保险产品和服务的分享。具体为用户基于“紫金保险线上平台”良好的使用感受度，在自身关系圈范围内通过网络链接、H5页面等对“紫金保险线上平台”在售保险产品、门店服务进行分享。</p>
            <p>4.2用户在使用“紫金保险线上平台”服务时，应遵守国家<span>《互联网保险业务监管暂行办法》、《计算机信息系统国际联网保密管理规定》、《中华人民共和国计算机信息系统安全保护条例》、《计算机信息网络国际联网安全保护管理办法》</span>等相关法律规定、“紫金保险线上平台”的相关协议及规则。不得从事以下行为：</p>
            <p class="stronger">4.2.1不得利用“紫金保险线上平台”进行虚假宣传；</p>
            <p class="stronger">4.2.2不得利用“紫金保险线上平台”销售非保险金融产品；</p>
            <p class="stronger">4.2.3不得利用“紫金保险线上平台”并以个人名义从事互联网保险销售；</p>
            <p class="stronger">4.2.4不得从事非法集资、保险欺诈、洗钱等违法违规行为；</p>
            <p class="stronger">4.2.5不得从事各种对紫金财产保险股份有限公司造成经济及声誉损失的行为；</p>
            <p class="stronger">4.2.6不得从事“紫金保险线上平台”用户授权范围外的行为；</p>
            <p class="stronger">4.2.7禁止恶意退保，“紫金保险线上平台”将定期跟踪异常退保情况，一经发现将追偿并追究相应责任；</p>
            <p class="stronger">4.2.8不得通过“紫金保险线上平台”发布、传播有关宗教、种族或性别等的贬损言辞；</p>
            <p class="stronger">4.2.9不得侵犯党和国家利益的言论；骚扰、滥用或威胁其他用户的信息、广告信息；</p>
            <p class="stronger">4.2.10不得侵犯任何第三方著作权、专利、商标、商业秘密或其他专有权利或名誉权的信息；</p>
            <p class="stronger">4.2.11不得干扰或破坏“紫金保险线上平台”或与“紫金保险线上平台”相连的服务器和网络及从事其他干扰或破坏“紫金保险线上平台”服务的活动，将“紫金保险线上平台”作任何非法用途；</p>
            <p class="stronger">4.2.12“紫金保险线上平台”用户需遵守注册协议内的各项约定，对于利用“紫金保险线上平台”用户身份在互联网线上或线下从事的违法违规行为，均由用户自行承担所有责任，同时我司会配合司法机关进行法律责任追究。用户违法违规行为损害到“紫金保险线上平台”合法权益时，我司将通过法律手段进行维权。</p>
            <p>5、用户账户管理</p>
            <p> 5.1在完成“紫金保险线上平台”的用户注册程序或以“紫金保险线上平台”允许的其他方式实际使用“紫金保险线上平台”服务时，“紫金保险线上平台”会提供唯一ID号的“紫金保险线上平台”账户（以下亦称“账户”）。用户可以对账户设置用户名、密码，通过该用户名、密码或经“紫金保险线上平台”授权的其他关联或合作网站的用户名密码登录“紫金保险线上平台”。<span>用户设置的用户名不得违反法律规定、不得侵犯他人合法权益。</span></p>
            <p class="stronger">5.2用户应当妥善保管用户名和密码，因密码泄露所致的损失自行承担。用户不得向其他任何人泄露用户名及密码，如发现任何人冒用或盗用用户名及密码或有任何其他可能危及账户安全的情形时，用户应当立即通知“紫金保险线上平台”，要求“紫金保险线上平台”暂停相关服务。“紫金保险线上平台”对在合理时间内采取行动但期间已产生的不良后果（包括但不限于用户的任何损失）不承担任何责任。</p>
            <p class="stronger">5.3除非有法律依据且征得“紫金保险线上平台”的同意，否则，用户的用户名和密码不得以任何方式转让、赠与或继承（与账户相关的财产权益除外）。</p>
            <p>6、费用</p>
            <p>注册“紫金保险线上平台”的用户及使用相应服务是免费的。“紫金保险线上平台”保留修改费用条款的权利，一旦费用条款被修改，将立即在网站上进行公示，进行公示后即视为已告知所有用户。</p>
            <p>7、信息授权条款</p>
            <p>7.1“紫金保险线上平台”非常重视用户的隐私权，将会尽最大努力保护用户的个人信息。除法律法规规定的情形外，未经用户许可“紫金保险线上平台”不会向第三方公开、透露用户个人信息。</p>
            <p>7.2“紫金保险线上平台”拥有完善的信息管理安全制度，为保障用户个人信息的安全，对重要用户信息采用了专业的加密存储与传输方式，以免用户信息遭受未经授权的访问、使用或披露。</p>
            <p>7.3用户在使用“紫金保险线上平台”的过程中，需要提供一些必要的个人信息，如姓名、手机号码、地理位置、银行账户、身份证或其他证件信息、车辆详细信息，因产品服务与实际使用功能相关联，若您提供的信息不完整、不真实，则可能在使用过程中受限或无法使用部分功能。</p>
            <p>7.4除法律另有规定之外，“紫金保险线上平台”有权因服务需要使用平台所有相关信息。</p>
            <p>7.5前述“信息”包括但不限于用户的身份信息、财产信息、账户信息、信用信息、交易信息、医疗健康信息、行踪轨迹信息、电子设备信息、电子设备操作日志及其他与用户相关的信息。</p>
            <p class="stronger">7.6如您不同意上述授权条款的部分或全部，应通过书面方式通知“紫金保险线上平台”取消或变更授权。</p>
            <p>7.7本条款自用户签署时生效，具有独立法律效力，不受本条款所属合同或协议成立与否及效力状态变化的影响。</p>
            <p class="stronger">8、责任声明</p>
            <p>8.1对使用“紫金保险线上平台”而产生的风险由用户自己承担，“紫金保险线上平台”明确不提供任何明示或者默示的担保。</p>
            <p>8.2“紫金保险线上平台”对下列事项不作任何陈述与保证：</p>
            <p>8.2.1“紫金保险线上平台”的服务符合用户的预期要求或经验；</p>
            <p>8.2.2用户使用“紫金保险线上平台”的服务后所产生的任何行为，如购买或获得的任何产品、服务、信息或其他事物等，符合用户的预期要求或经验；</p>
            <p>8.2.3用户需独立承担因网站意外中断、操作或传输的迟延、电脑病毒、网络连接故障、未经授权的进入等引起的损失，“紫金保险线上平台”不承担责任。</p>
            <p>8.2.4 “紫金保险线上平台”不对用户因网站意外中断、操作或传输的迟延、电脑病毒、网络连接故障、未经授权的进入等引起的损失承担责任。</p>
            <p>8.3用户因违反“紫金保险线上平台”注册协议或其他有关的法律、法规，而导致有第三方对紫金财产保险股份有限公司提起诉讼或索赔要求时，用户需要赔偿紫金财产保险股份有限公司因此遭受的所有损失，包括但不限于全部经济损失、诉讼费用和律师费等。</p>
            <p>8.4“紫金保险线上平台”对用户在“紫金保险线上平台”上公布的信息中查找到的内容不负责任，对信息的即时性、安全性和正确性也不作保证。对通过“紫金保险线上平台”获取的任何信息，用户需自己甄别，自负风险；对因下载或引用“紫金保险线上平台”的数据、信息而造成的用户计算机系统损坏或数据丢失，“紫金保险线上平台”不负责任。</p>
            <p>8.5“紫金保险线上平台”对用户使用“紫金保险线上平台”上公布的或其服务中的建议和资讯而造成的损失或伤害以及用户相信“紫金保险线上平台”上的公布的或其服务中的建议和资讯而做出的决定或采取的行动不负责任。对“紫金保险线上平台”提供的部分或所有服务不满，用户唯一的补救措施是停止使用这些服务。</p>
            <p>8.6“紫金保险线上平台”含有与其他网站的链接。“紫金保险线上平台”与链接的网站有合作关系，但并不能控制这些网站及其所提供的资源，所以“紫金保险线上平台”对链接网站上的内容、广告、服务、产品信息的真实有效性不负责任，并且对因链接网站上的内容、广告、服务、产品信息的失实而造成的损失不负任何法律责任。</p>
            <p class="stronger">9、知识产权声明</p>
            <p>9.1“紫金保险线上平台”上所有可阅读的资料等都受到<span>《中华人民共和国著作权法》</span>等法律的保护。</p>
            <p>9.2“紫金保险线上平台”上所有内容的选材、整理、编排、排版，以及由“紫金保险线上平台”创作的文字、图片等作品的著作权，无论是否明示，均属“紫金保险线上平台”所有。任何组织或个人未经“紫金保险线上平台”书面许可，不得修改、出版、传播、参与传播、销售、制作衍生作品，或以其他任何方式使用整体或部分的“紫金保险线上平台”上的内容。</p>
            <p>9.3“紫金保险线上平台”对其开发或者合作开发的系统等享有知识产权。“紫金保险线上平台”的所有权利受法律保护。</p>
            <p>9.4“紫金保险线上平台”，是紫金财产保险股份有限公司所有、使用的商标。</p>
            <p>9.5所有其他在“紫金保险线上平台”上出现的商标为它们各自的权利人所有。</p>
            <p>9.6“紫金保险线上平台”尊重和保护他人的知识产权。不允许在没有著作权、商标权或其他专有权权利人明确许可的情况下，发布或者传播任何可能侵犯他人权利的信息、图片。行为人承担由此产生的全部责任。</p>
            <p class="stronger">10、协议中止与终止</p>
            <p class="stronger">出现以下情形，“紫金保险线上平台”有权在告知或未经告知的情况下中止或终止协议及部分或全部服务，无须因此承担任何责任，且保留追究用户下列行为法律责任的权利：</p>
            <p>10.1向“紫金保险线上平台”提供的信息或资料不真实、不准确、不即时、不完整；</p>
            <p>10.2实施或计划实施破坏、攻击“紫金保险线上平台”的电脑系统、网络的完整性，或者试图擅自进入“紫金保险线上平台”电脑系统、网络；</p>
            <p>10.3使用或提供含有毁坏、干扰、截取或侵占任何系统、数据或个人资料的任何电脑病毒、伪装破坏程序、电脑蠕虫、定时程序炸弹或其他破坏性程序；</p>
            <p>10.4盗用他人在“紫金保险线上平台”上的用户名或密码；</p>
            <p>10.5未经“紫金保险线上平台”书面同意，擅自允许他人使用“紫金保险线上平台”的服务（包括但不限于擅自允许他人使用其用户名或密码，或者擅自将其用户名或密码转让给他人的），或者通过“紫金保险线上平台”获得相关信息。</p>
            <p>10.6出现其他任何违法、违纪或违约的情形。</p>
            <p>协议中止期间，用户的账户将被冻结，用户将无法使用“紫金保险线上平台”平台部分或全部功能，也不再享有任何形式的平台利益。即使注册协议重新生效，用户也无权对协议中止期间任何利益进行回溯。一旦协议、服务被终止，“紫金保险线上平台”有权随时删除您在“紫金保险线上平台”的注册信息及相关资料；对用户在服务中止或终止前的行为，“紫金保险线上平台”保留追究法律责任的权利。</p>
            <p>11、法律适用及管辖</p>
            <p>本协议条款的解释及适用，以及与本协议条款有关的争议，均应依照中华人民共和国法律（不包含港澳台地区的法律）予以处理，并以紫金财产保险股份有限公司总部所在地人民法院为管辖法院。</p>
        </div>
        <div v-if="isScret">
            <iframe src="https://open.zking.com/cms/uploads/15/product/2022111/html/app-list-def-v1/ysxy.html" title="">
            </iframe>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return{
            isScret: false
        }
    },
    created() {
        this.isScret = this.$route.query.isScret === '1' 
        localStorage.setItem('Agreement','Agreement')
    }

}
</script>

<style lang="scss" scoped>
.agreement{
    padding: 0.15rem;
    background-color: white;
    p{
        font-size: 0.14rem;
        line-height: 0.25rem;
        span{
            font-weight: bold;
        }
    }
    .stronger{
        font-weight: bold
    }
}
iframe {
  margin: 0;
  padding: 0;
  padding-top: 0.2rem;
  // padding-left: 0.2rem;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  border: 0px;
  margin-right: -50px;
}
</style>



// WEBPACK FOOTER //
// src/pages/motor/components/motorLogin/components/agreement.vue